import { RouteConf, UserRole } from "types";

export function menusFilter(
  routes: RouteConf[],
  role: UserRole | undefined,
): RouteConf[] {
  if (!role) {
    return [];
  }
  return routes.filter((route) => {
    if (route.access.roles && route.access.roles.includes(role)) {
      return true;
    }
    if (route.access.exclude && !route.access.exclude.includes(role)) {
      return true;
    }
    return false;
  });
}

// Utilitaires de formatage de dates
export const formatDate = (date: Date | string): string => {
  const dateObj = typeof date === "string" ? new Date(date) : date;
  return dateObj.toLocaleDateString("fr-FR", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

export const formatDateTime = (
  date: Date | string,
): { date: string; time: string } => {
  const dateObj = typeof date === "string" ? new Date(date) : date;
  return {
    date: dateObj.toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
    }),
    time: dateObj.toLocaleTimeString("fr-FR", {
      hour: "2-digit",
      minute: "2-digit",
    }),
  };
};

export const formatTime = (date: Date | string): string => {
  const dateObj = typeof date === "string" ? new Date(date) : date;
  return dateObj.toLocaleTimeString("fr-FR", {
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const canJoinSession = (scheduledDate: Date | string): boolean => {
  const dateObj =
    typeof scheduledDate === "string" ? new Date(scheduledDate) : scheduledDate;
  const now = new Date();
  const timeDiff = dateObj.getTime() - now.getTime();
  const minutesUntil = timeDiff / (1000 * 60);

  // Peut rejoindre 15 minutes avant et jusqu'à 1 heure après
  return minutesUntil >= -15 && minutesUntil <= 60;
};

export const getTimeUntilSession = (scheduledDate: Date | string): string => {
  const dateObj =
    typeof scheduledDate === "string" ? new Date(scheduledDate) : scheduledDate;
  const now = new Date();
  const timeDiff = dateObj.getTime() - now.getTime();
  const minutesUntil = timeDiff / (1000 * 60);

  if (minutesUntil < 0) {
    const hoursAgo = Math.abs(Math.floor(minutesUntil / 60));
    const minutesAgo = Math.abs(Math.floor(minutesUntil % 60));
    if (hoursAgo > 0) {
      return `Il y a ${hoursAgo}h ${minutesAgo}min`;
    }
    return `Il y a ${minutesAgo}min`;
  }

  const hoursUntil = Math.floor(minutesUntil / 60);
  const minutesRemaining = Math.floor(minutesUntil % 60);

  if (hoursUntil > 0) {
    return `Dans ${hoursUntil}h ${minutesRemaining}min`;
  }
  return `Dans ${minutesRemaining}min`;
};
